import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-calendar-item-edit-related-services',
  templateUrl: './calendar-item-edit-related-services.component.html',
  styleUrls: ['./calendar-item-edit-related-services.component.css']
})
export class CalendarItemEditRelatedServicesComponent implements OnInit {

  @Input() public isExcluded: boolean;
  @Input() public serviceIds: string[];
  @Input() public title: string;
  @Output() public servicesChanged: EventEmitter<string[]> = new EventEmitter();

  public newServiceId: string;
  public isAddingNewService: boolean; 

  constructor() { }

  ngOnInit() {
  }

  public addService() { 
    this.serviceIds.push(this.newServiceId);
    this.isAddingNewService = false;
    this.newServiceId = "";
  }

  public delete(item) { 
    console.log("delete", item);
    this.serviceIds = this.serviceIds.filter((s) => {return s != item});
    this.servicesChanged.emit(this.serviceIds);
  }

}
